import React, { FunctionComponent } from 'react';
import DefaultStackedBarChart from '../default-stacked-bar-chart';
import { CallSourceChartData } from './calls-source-graph-repository';
import { convertToStackedBarData } from '../utils/convert-to-stacked-bar-data';
import {
  getCallSourceColors,
  getCallSourceLabels,
  getOrderedCallSources,
} from 'pages/dashboard/utils/call-source-display';

type CallsSourceGraphViewProps = {
  chartData: CallSourceChartData[];
  availableSources: string[];
};

const CallsSourceGraphView: FunctionComponent<CallsSourceGraphViewProps> = ({
  chartData,
  availableSources,
}) => {
  const now = new Date();
  const year = now.getFullYear();

  const validSources = availableSources.filter(
    (source) => source != null && typeof source === 'string',
  );

  const orderedSources = getOrderedCallSources(validSources);
  const sourceLabels = getCallSourceLabels(orderedSources);
  const colors = getCallSourceColors(orderedSources);

  const options = {
    dateField: 'month',
    fields: orderedSources.map((source) => ({
      sourceField: source,
      targetField: sourceLabels[source] || source,
    })),
    year: year,
  };

  const keys = options.fields.map((field) => field.targetField);
  const formattedData = convertToStackedBarData(chartData, options);

  return (
    <DefaultStackedBarChart
      data={formattedData}
      keys={keys}
      indexBy="month"
      showPercentages
      colors={colors}
    />
  );
};

export default CallsSourceGraphView;
